module.exports = __webpack_public_path__ + "img/payment-logos-standard.6eb1bcff.png";